import {useLayoutEffect, useRef} from 'react';
import {Outlet, useRouterState} from '@tanstack/react-router';
import {Toaster} from '@/shared/ui/components/sonner';

/**
 * Root composition shell.
 *
 * Vertical scrolling is owned by `.app-shell` (not the document) so mobile
 * browsers do not rubber-band the page behind fixed chrome. The Toaster stays
 * outside the scroller so fixed positioning is not nested under overflow.
 */
export const RootLayout = () => {
  const pathname = useRouterState({select: state => state.location.pathname});
  const shellRef = useRef<HTMLDivElement>(null);

  // TanStack restores window scroll by default; with a custom scroller we
  // reset the shell on route changes (pathname only — query updates can keep offset).
  useLayoutEffect(() => {
    shellRef.current?.scrollTo({top: 0, left: 0});
  }, [pathname]);

  return (
    <>
      <div ref={shellRef} className="app-shell" data-app-shell="">
        <Outlet />
      </div>
      <Toaster position="top-center" />
    </>
  );
};
